import React, { useEffect, useState } from "react";
import SideBar from "../../Components/Navbar/Sidebar";
import { months } from "../../Components/Apis/apis";
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { getAllOrder } from "../../Components/Apis/apis";
const Revenue = () => {
  const [state, setstate] = useState([]);
  const [year, setYear] = useState("");
  const [filterData, setFilterData] = useState([]);
  const currentYear = new Date().getFullYear();
  const clients = async () => {
    const data = await getAllOrder();
    data.map((el) => {
      el["year"] = el.start_date.slice(0, 4);
      el["monthwithyear"] = el.start_date.slice(0, 7);
    });

const dataStatus = data.filter((el)=>el.status==1 && el.month !=0)
    setstate(dataStatus);
    setFilterData(data);
  
  };

  useEffect(() => {
    clients();
  }, []);
  
  const allyaers = state.map((el) => el.year);
  

  const yearss = [...new Set(allyaers)];
  const years= yearss.filter((el) => el !== "0000");

 
  const filterYear = async () => {
    const data = state.filter((el) => el.year == year);
    setFilterData(data);
   
  };
  

  useEffect(() => {
    filterYear();
  }, [year]);


  const jan = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-01`
  );

  var jan_result = jan.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;

  },0);


  const feb = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-02`
  );
  var feb_result = feb.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;

  },0);
  const mar = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-03`
  );
  var mar_result = mar.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;

  },0);
  const apr = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-04`
  );
  var apr_result = apr.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;

  },0);
  const may = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-05`
  );
  var may_result = may.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;

  },0);
  const jun = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-06`
  );
  var jun_result = jun.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;
  },0);

  const jul = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-07`
  );
  var jul_result = jul.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;
  },0);

  const aug = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-08`
  );
  var aug_result = aug.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;
  },0);

  const sep = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-09`
  );
  var sep_result = sep.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;
  },0);
  const oct = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-10`
  );
 
  var oct_result = oct.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;
  },0);

  const nov = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-11`
  );
  var nov_result = nov.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;
  },0);

  const dec = filterData.filter(
    (el) => el.monthwithyear === `${!year ? currentYear : year}-12`
  );


  var dec_result = dec.reduce(function(tot, arr) { 
    return tot + arr.paid_amount;
  },0);

  const Category = {
    labels: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    datasets: [
      
      {
        label: "Order from user",
        fill: true,
        color: "red",
        borderWidth: 2,
        pointRadius: 2,
        data: [
          jan_result,
          feb_result,
          mar_result,
          apr_result,
          may_result,
          jun_result,
          jul_result,
          aug_result,
          sep_result,
          oct_result,
          nov_result,
          dec_result,
        ],
      },
    ],
  };

  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="container-pages">
        <div className="page-title">
          <h2>
            Revenue
            <div className="float-end me-4">
            <DropdownButton
                title={year ? <>Year {year}</> : <> Select year </>}
                id="select-media-box"
                onSelect={(e) => setYear(e)}
                className="  ms-2"
              >
                {years.map((el, i) => (
                  <Dropdown.Item eventKey={el} className="" key={i}>
                    {el}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </div>
          </h2>
        </div>
        <div className="main-div">
          <Bar data={Category} />
        </div>
      </div>
    </div>
  );
};

export default Revenue;
